const SCALE_REDIRECT_URL = 'spellbook/apps';
const ENCODED_REDIRECT_URL = encodeURIComponent(SCALE_REDIRECT_URL);
const BASE_SCALE_FRONTEND_URL =
  process.env.REACT_APP_SCALE_AI_FRONTEND_URL ?? 'https://dashboard.scale.com';
export const LOGIN_REDIRECT_URL = `${BASE_SCALE_FRONTEND_URL}/login?redirect_url=${ENCODED_REDIRECT_URL}&product=${ENCODED_REDIRECT_URL}`;
export const SIGNUP_REDIRECT_URL = `${BASE_SCALE_FRONTEND_URL}/signup?redirect_url=${ENCODED_REDIRECT_URL}&product=${ENCODED_REDIRECT_URL}`;
export const LOGOUT_REDIRECT_URL =
  'https://auth.dashboard.scale.com/dashboard/logout?redirect_url=/spellbook/app';
